<template>
  <div class="rmb">
    <!-- <i-title titleText="数字转人民币大写"></i-title> -->
    <div class="wrapper">
      <textarea class="default-text" v-model="leftVal" placeholder="输入小写数字金额"></textarea>
      <textarea class="minify-text" id="rmbCode" v-model="rightVal" placeholder="转换结果"></textarea>
    </div>
    <div class="btn-wrap">
      <button class="btn btn-default" @click="changeNumber">
        转为人民币大写
      </button>
      <button
        class="btn btn-copy"
        id="cppyBtn"
        @click="handleCopy"
        data-clipboard-target="#rmbCode"
      >
        {{ copyText }}
      </button>
    </div>
    <div class="des-wrap">
      <h3>数字对应大写列表</h3>
      <div class="des-list first-list">
        <dl>
          <dt>零</dt>
          <dd>0</dd>
        </dl>
        <dl>
          <dt>壹</dt>
          <dd>1</dd>
        </dl>
        <dl>
          <dt>贰</dt>
          <dd>2</dd>
        </dl>
        <dl>
          <dt>叁</dt>
          <dd>3</dd>
        </dl>
        <dl>
          <dt>肆</dt>
          <dd>4</dd>
        </dl>
        <dl>
          <dt>伍</dt>
          <dd>5</dd>
        </dl>
        <dl>
          <dt>陆</dt>
          <dd>6</dd>
        </dl>
        <dl>
          <dt>柒</dt>
          <dd>7</dd>
        </dl>
        <dl>
          <dt>捌</dt>
          <dd>8</dd>
        </dl>
        <dl>
          <dt>玖</dt>
          <dd>9</dd>
        </dl>
      </div>
      <h3 class="list-title">金额单位(位数)对应表</h3>
      <div class="des-list last-list">
        <dl>
          <dt>亿</dt>
          <dd>亿</dd>
        </dl>
        <dl>
          <dt>万</dt>
          <dd>万</dd>
        </dl>
        <dl>
          <dt>仟</dt>
          <dd>仟(千)</dd>
        </dl>
        <dl>
          <dt>佰</dt>
          <dd>佰(百)</dd>
        </dl>
        <dl>
          <dt>拾</dt>
          <dd>拾(十)</dd>
        </dl>
        <dl>
          <dt>元</dt>
          <dd>元(圆)</dd>
        </dl>
        <dl>
          <dt>角</dt>
          <dd>角</dd>
        </dl>
        <dl>
          <dt>分</dt>
          <dd>分</dd>
        </dl>
        <dl>
          <dt>整</dt>
          <dd>整</dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import ClipboardJS from 'clipboard'
import { ElMessage } from 'element-plus'

export default {
  name: 'Huoxingwen',
  data () {
    return {
      leftVal: '',
      rightVal: '',
      copyText: '复制'
    }
  },
  methods: {
    changeNumber () {
      this.rightVal = this.convertCurrency(this.leftVal)
    },
    convertCurrency (currencyDigits) {
      var MAXIMUM_NUMBER = 99999999999.99
      var CN_ZERO = '零'
      var CN_ONE = '壹'
      var CN_TWO = '贰'
      var CN_THREE = '叁'
      var CN_FOUR = '肆'
      var CN_FIVE = '伍'
      var CN_SIX = '陆'
      var CN_SEVEN = '柒'
      var CN_EIGHT = '捌'
      var CN_NINE = '玖'
      var CN_TEN = '拾'
      var CN_HUNDRED = '佰'
      var CN_THOUSAND = '仟'
      var CN_TEN_THOUSAND = '万'
      var CN_HUNDRED_MILLION = '亿'
      var CN_SYMBOL = ''
      var CN_DOLLAR = '元'
      var CN_TEN_CENT = '角'
      var CN_CENT = '分'
      var CN_INTEGER = '整'

      var integral
      var decimal
      var outputCharacters
      var parts
      var digits, radices, bigRadices, decimals
      var zeroCount
      var i, p, d
      var quotient, modulus

      currencyDigits = currencyDigits.toString()
      if (currencyDigits === '') {
        return ''
      } else {
        var strtemp = currencyDigits.split('-')
        if (strtemp.length > 1) {
          currencyDigits = strtemp[1]
        }
      }
      if (currencyDigits.match(/[^,.\d]/) != null) {
        ElMessage.error('包含无效字符，请输入正确的数字金额！')
        return ''
      }
      if (currencyDigits.match(/^((\d{1,3}(,\d{3})*(.((\d{3},)*\d{1,3}))?)|(\d+(.\d+)?))$/) == null) {
        ElMessage.error('请输入正确的数字金额！')
        return ''
      }

      currencyDigits = currencyDigits.replace(/,/g, '')
      currencyDigits = currencyDigits.replace(/^0+/, '')

      if (Number(currencyDigits) > MAXIMUM_NUMBER) {
        ElMessage.error('数字太大了！')
        return ''
      }
      parts = currencyDigits.split('.')
      if (parts.length > 1) {
        integral = parts[0]
        decimal = parts[1]
        decimal = decimal.substr(0, 2)
      } else {
        integral = parts[0]
        decimal = ''
      }
      digits = [
        CN_ZERO,
        CN_ONE,
        CN_TWO,
        CN_THREE,
        CN_FOUR,
        CN_FIVE,
        CN_SIX,
        CN_SEVEN,
        CN_EIGHT,
        CN_NINE
      ]
      radices = ['', CN_TEN, CN_HUNDRED, CN_THOUSAND]
      bigRadices = ['', CN_TEN_THOUSAND, CN_HUNDRED_MILLION]
      decimals = [CN_TEN_CENT, CN_CENT]
      outputCharacters = ''
      if (Number(integral) > 0) {
        zeroCount = 0
        for (i = 0; i < integral.length; i++) {
          p = integral.length - i - 1
          d = integral.substr(i, 1)
          quotient = p / 4
          modulus = p % 4
          if (d === '0') {
            zeroCount++
          } else {
            if (zeroCount > 0) {
              outputCharacters += digits[0]
            }
            zeroCount = 0
            outputCharacters += digits[Number(d)] + radices[modulus]
          }
          if (modulus === 0 && zeroCount < 4) {
            outputCharacters += bigRadices[quotient]
          }
        }
        outputCharacters += CN_DOLLAR
      }

      if (decimal !== '') {
        for (i = 0; i < decimal.length; i++) {
          d = decimal.substr(i, 1)
          if (d !== '0') {
            outputCharacters += digits[Number(d)] + decimals[i]
          }
        }
      }
      if (outputCharacters === '') {
        outputCharacters = CN_ZERO + CN_DOLLAR
      }
      if (decimal === '' || decimal === 0) {
        outputCharacters += CN_INTEGER
      }
      outputCharacters = CN_SYMBOL + outputCharacters
      return outputCharacters
    },
    handleCopy () {
      if (this.rightVal) {
        var clipboard = new ClipboardJS('#cppyBtn');
        const that = this
        clipboard.on('success', function(e){
          e.clearSelection();
          that.copyText = '已复制'
        })
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.sql {
  width: 1200px;
  margin: 0 auto;
}
.wrapper {
  width: 1200px;
  height: 100px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
}
.wrapper textarea {
  box-sizing: border-box;
  width: 590px;
  border: 1px solid #eee;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  line-height: 1.3em;
  position: relative;
  overflow: hidden;
  background-color: #fff;
  height: 100%;
  margin-bottom: 9px;
  color: #555555;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  border-collapse: collapse;
  transition: border linear 0.2s, box-shadow linear 0.2s;
  resize: none;
  padding: 5px 15px;
}
.wrapper textarea:focus {
  border-color: #1890ff;
  outline: 0;
}
.btn-wrap {
  display: flex;
}
.btn {
  height: 42px;
  font-size: 14px;
  border: 0;
  cursor: pointer;
  border-radius: 4px;
  margin-right: 10px;
  margin-top: 22px;
  padding: 0 15px;
  min-width: 100px;
  box-sizing: border-box;
  color: #fff;
}
.btn:hover {
  opacity: 0.8;
}
.btn.btn-default{
  background: #409eff;
}
.btn.btn-copy{
  background: #fff;
  color: #606266;
  border: 1px solid #dcdfe6;
}
.btn.btn-copy:hover{
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}
.des-wrap
  border 1px solid #ddd
  border-radius 3px
  background #fff
  padding 25px 20px 40px
  margin 40px 0 0
  h3
    color #333
    padding-bottom 20px
  .list-title
    margin-top 30px
.des-list
  display flex
  justify-content space-between
  dl
    text-align center
    line-height 1
    box-sizing border-box
    border 1px dashed #dedede
    border-radius 4px
    padding 20px 40px
  dt
    font-weight bold
    font-size 24px
    padding-bottom 20px
    color #333
  dd
    font-size 18px
    color #666
  &.last-list
    dl
      padding 20px 0
      width 10%
</style>
